import apiFetch from '@wordpress/api-fetch';

export class Notice {

	static active = [];

	static stati = {
		success: 'Success!',
		info   : 'Information',
		error  : 'An unknown error has occurred',
	};

	constructor( code, message, timeout = 5000 ) {
		this.code = code || 'error';
		this.message = message || this.constructor.stati[ this.code ] || this.constructor.stati.error;
		this.timeout = Math.max( 2000, timeout );

		this.node = document.createElement( 'button' );
		this.node.type = 'button';
		this.node.classList.add( 'preferences__notice', `preferences__notice--${ this.code }` );
		this.node.addEventListener( 'click', this.close.bind( this ) );

		const icon = document.createElement( 'i' );
		icon.appendChild( document.createTextNode( '✕' ) );
		this.node.appendChild( icon );

		const text = document.createElement( 'span' );
		text.appendChild( document.createTextNode( this.message ) );
		this.node.appendChild( text );
	}

	appendTo( where = document.body ) {
		if ( this.constructor.active.length ) {
			for ( let notice of this.constructor.active ) {
				notice.close();
			}
		}

		where.appendChild( this.node );
		this.constructor.active.push( this );

		setTimeout( this.close.bind( this ), this.timeout );
	}

	close() {
		this.node.addEventListener( 'animationend', () => this.remove() );
		this.node.classList.add( 'preferences__notice--out' );
	}

	remove() {
		if ( this.node.parentNode ) {
			this.node.parentNode.removeChild( this.node );
		}

		this.constructor.active = this.constructor.active.filter( n => n !== this );
	}
}

export async function onSubmit( e ) {
	e.preventDefault();

	const { code, message } = await submit( this );

	const notice = new Notice( code, message );
	notice.appendTo( this );
}

export async function submit( form, headers = {} ) {
	let   response = null;
	const disabled = form.querySelectorAll( 'fieldset, button[type="submit"]' );
	const method   = form?.method ?? 'GET';
	const url      = form.action;

	headers = {
		'Accept'      : 'application/json',
		'Content-Type': 'application/x-www-form-urlencoded',
		...headers
	};

	form.classList.add( 'is-loading' );

	try {
		const body = new URLSearchParams( new FormData( form ) );

		disabled.forEach( elem => elem.disabled = true );

		response = await apiFetch( {
			method,
			url,
			body,
			headers,
		} );
	} catch ( fault ) {
		response = fault;
		console.error( response );
	} finally {
		form.classList.remove( 'is-loading' );
		disabled.forEach( elem => elem.removeAttribute( 'disabled' ) );
	}

	return response;
}

export function init( node ) {
	if ( node instanceof HTMLFormElement ) {
		node.addEventListener( 'submit', onSubmit );
	} else {
		for ( const form of node.querySelectorAll( 'form' ) ) {
			form.addEventListener( 'submit', onSubmit );
		}
	}
}

for ( const node of document.querySelectorAll( '.preferences' ) ) {
	init( node );
}
